import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";
import ArrayLabel from "components/common/ArrayLabel/ArrayLabel";

const ColumnsList: ColumnsEdit = [
  {
    title: "Mã vật tư",
    dataIndex: "code",
    key: "code",
    show: true,
    align: "left",
  },
  {
    title: "Tên vật tư",
    dataIndex: "name",
    key: "name",
    show: true,
    align: "left",
  },
  {
    title: "Đơn vị tính",
    dataIndex: "donViTinh",
    key: "unit",
    show: true,
    align: "center",
  },
  {
    title: "Loại vật tư",
    dataIndex: "loaiVatTu",
    key: "loaiVatTu",
    show: true,
    align: "left",
  },
  {
    title: "Vật liệu",
    dataIndex: "vatLieu",
    key: "vatLieu",
    show: true,
    align: "left",
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    render(value, record, index) {
      let text = "";
      if (value == 0) {
        text = "Nam";
      }
      if (value == 1) {
        text = "Nữ";
      }
      return <>{text}</>;
    },
    show: true,
    align: "left",
  },
  {
    title: "Hãng sản xuất",
    dataIndex: "hangSanXuat",
    key: "hangSanXuat",
    show: true,
    align: "left",
  },
  {
    title: "Đặc điểm khác",
    dataIndex: "dacDiemKhac",
    key: "dacDiemKhac",
    show: true,
  },
  {
    title: "Kho quản lý",
    dataIndex: "storeDtos",
    key: "storeDtos",
    show: true,
    render(value, record, index) {
      return (
        <ArrayLabel
          data={value?.map(e => {
            return e?.name;
          })}
        ></ArrayLabel>
      );
    },
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    key: "ghiChu",
    show: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    width: 80,
  },
];

export {ColumnsList};
